import React from "react";
import CustomTable from "../../components/CustomTable";
import { getCities } from "../../../services/CommonServices";
import AddUpdateCity from "./AddUpdate";
import { cityValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";

const City = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage, pageSize) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "State",
      render: (row, index) => <span>{row?.state?.name}</span>,
    },
    {
      label: "Name",
      key: "name",
    },
    // {
    //   label: "Code",
    //   key: "code",
    // },
  ];
  const modalConfig = {
    initialValues: {
      state: "",
      name: "",
      code: "",
    },
    validationSchema: cityValidationSchema,
    apiUrl: "master/cities",
    FormComponent: AddUpdateCity,
    addTitle: "Add City",
    updateTitle: "Update City",
    extraProps: {
      relationKeys: ["state"],
    },
  };
  return (
    <CustomTable
      title="Cities"
      addBtnTitle="Add New City"
      columns={columns}
      getHook={getCities}
      store={"city"}
      deleteHook={"master/cities"}
      formModal={true}
      modalConfig={modalConfig}
      search={true}
    />
  );
};

export default City;
